import api from "./api";
import { Posicion } from "src/utils";

export default {
  async puntoDeServicioCercanos(latitud: number, longitud: number) {
    return api.get(
      `punto_servicio/ubicaciones_cercanas?latitud=${latitud}&longitud=${longitud}`
    );
  },

  async marcarEntrada(puntoDeServicio: string, posicion: Posicion) {
    return this.marcar(puntoDeServicio, "HE", posicion);
  },

  async marcarSalida(puntoDeServicio: string, posicion: Posicion) {
    return this.marcar(puntoDeServicio, "HS", posicion);
  },

  async marcar(puntoDeServicio: string, accion: string, posicion: Posicion) {
    const payload = {
      accion: accion,
      ps_codigo: puntoDeServicio,
      latitud: posicion.latitud,
      longitud: posicion.longitud,
      origen: "app",
    };

    return api.post(`punto_servicio/marcar`, payload);
  },
};
